import axios from "@app2/api/axios";
import {set} from "@app2/utils/helpers";
import Widget from "@app2/models/Widget";
import analytics from "@app2/modules/Wisdom/Analytics/analytics.store";

const namespaced = true;

const state = {
  plugin: null,
  previewLogo: null,
  slideInData: null,
  previewOpen: false,
};

const mutations = {
  SET_PLUGIN(state, payload) {
    state.plugin = payload;
  },
  SET_PREVIEW_LOGO(state, payload) {
    state.previewLogo = payload
  },
  SET_SLIDE_IN_DATA(state, payload) {
    state.slideInData = payload
  },
  SET_PREVIEW_OPEN(state, payload) {
    state.previewOpen = payload
  },
};

const actions = {
  async addLogo({state, commit}, plugin) {
    if ( !state.previewLogo ) return false;
    const formData = new FormData();
    formData.append('logo', state.previewLogo);
    let {data: logo} = await axios.post(`/api/widgets/${plugin.hash}/upload/logo`, formData, {
      headers: { 'content-type': 'multipart/form-data'},
    });
    if ( logo ) {
      set(plugin, 'settings.logo_url', logo.settings.logo_url);
      await Widget.insertOrUpdate({
        data: plugin,
      });
      commit('SET_PREVIEW_LOGO', false);
    }
  },
  getSnapshot({commit}, hash) {
    axios.get(`/api/widgets/${hash}/analytics/snapshot`).then(({data}) => {
      commit('SET_SNAPSHOT', data)
    })
  },
  getActivity({commit}, hash) {
    axios.get(`/api/widgets/${hash}/analytics/activity`, {params: {page: state.activityCurrentPage}}).then(({data}) => {
      commit('SET_ACTIVITY', data)
    })
  },
};

const getters = {
  slideInData: state => state.slideInData,
  previewOpen: state => state.previewOpen,
};

const modules = {
  analytics,
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
  modules,
};
